module.exports = __webpack_public_path__ + "static/media/yandex-mail.e463fd18.png";